import { render, staticRenderFns } from "./Standard.vue?vue&type=template&id=799f924a&scoped=true"
var script = {}
import style0 from "./Standard.vue?vue&type=style&index=0&id=799f924a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799f924a",
  null
  
)

export default component.exports